import '../css/page.css';
import { Container, Row, Carousel } from 'react-bootstrap';

function Page5() {

  const features = [
    {
      title: "AI-Powered College Matching",
      description: "Get personalized university recommendations based on your profile and goals.",
      image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Replace with actual images
    },
    {
      title: "Scholarship and Internships Finder",
      description: "Explore thousands of scholarships and internships that match your profile.",
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      title: "Resume & Essay Builder",
      description: "Use AI to refine your personal statement and craft a standout resume.",
      image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?q=80&w=2672&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      title: "Mock Interview AI Coach",
      description: "Practice with AI-driven mock interviews and get real-time feedback.",
      image: "https://plus.unsplash.com/premium_photo-1678871481624-efc5e8a3f539?q=80&w=2564&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      title: "Admission Benchmark",
      description: "Get insights on where you stand on getting into your dream universities, based on your profile and local admission data.",
      image: "https://images.unsplash.com/photo-1581574919402-5b7d733224d6?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    }
  ]

  return (
    <div className='ContentWrapper' style={{ display: 'flex' }}>
      <Container>
        <Row>
          <h2 className='SubHeading' style={{ paddingTop: '5rem' }}>
            Features that <b style={{ color: '#1E3A8A' }}>Stand Out</b>
          </h2>
        </Row>
        <Row style={{ paddingTop: '3rem' }}>
          <div className='ContentWrapper' style={{ display: 'flex' }}>
            <Carousel style={{ borderRadius: '30px', overflow: 'hidden'}}>
              {features.map((feature, index) => (
                <Carousel.Item key={index}>
                  <img className="d-block w-100" src={feature.image} alt={feature.title} style={{objectFit: 'cover', height: '500px', width: '100%', maxHeight: '500px'}} />
                  <Carousel.Caption style={{justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0, 0, 0, 0.5)', borderRadius: '10px', padding: '10px' }}>
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </Carousel.Caption>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default Page5;

// TODO: A page specifically for more detailed features, the comparison feature

// take your next step with confidence
// by your side at every step of the way?
